import request from "./useRequests";
import { userinfo } from '@/stores/counter'
import { ElMessage } from 'element-plus'
import getStatus from '@/api/getStatus'

export default function usesignup() {
  const user = userinfo();
  const { status } = getStatus();
  async function signup(phone: string, mail: string, nickname: string, passwd: string, avatar: string, address: string, career: string) {
    // console.log(phone, mail, nickname, passwd, avatar)
    if (!mail || !nickname || !passwd || !avatar || !address || !career) {
      ElMessage({
        showClose: true,
        message: '不能输入空字符',
        type: 'error',
      })
      return 0
    }
    try {
      const res = await request.post('/user/register', {
        "telephone": phone,
        "email": mail,
        "nickname": nickname,
        "password": passwd,
        "avatar": avatar,
        "address": address,
        "career": career
      })
      if (res.data.success == true) {
        ElMessage({
          showClose: true,
          message: '注册成功',
          type: 'success',
        })
        user.signup = false;
        user.login = true;
        status();
      } else {
        ElMessage({
          showClose: true,
          message: `${res.data.message}`,
          type: 'error',
        })
      }
    } catch (err: any) {
      //alert(err)
    }
  }

  return {
    signup
  }
}